import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { AuthGate } from './AuthGate'
import { ToastProvider } from './components/ToastProvider'
import './index.css'
import './App.css'

// iOS Safari: add touchstart listener so the browser treats elements as "touchable"
// and fires click events immediately without waiting for double-tap
document.addEventListener('touchstart', () => {}, { passive: true });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ToastProvider>
      <AuthGate>
        <App />
      </AuthGate>
    </ToastProvider>
  </React.StrictMode>,
)
